import { PostCheckoutMandatoryQuestionsInAppVariant } from '../../constants/statsig';
import { getPostCheckoutMandatoryQuestionsInAndroidApp } from './getPostCheckoutMandatoryQuestionsInAndroidApp';
import { getPostCheckoutMandatoryQuestionsInIosApp } from './getPostCheckoutMandatoryQuestionsInIosApp';

export const getPostCheckoutMandatoryQuestionsInApp =
    (): PostCheckoutMandatoryQuestionsInAppVariant => {
        const androidExperimentValue =
            getPostCheckoutMandatoryQuestionsInAndroidApp();

        return androidExperimentValue ===
            PostCheckoutMandatoryQuestionsInAppVariant.optionalQuestionsInApp
            ? getPostCheckoutMandatoryQuestionsInIosApp()
            : androidExperimentValue;
    };
